import React from "react";
import "./Home.css";
import { SubmissionButton } from "../SumbissionButton";

export const WorkPaperCalls = () => {
  return (
    <div className="page-layout">
      <div className="text-layout">
        <h2>Call for Workshop Papers</h2>
        <p>
          SMARTCOMP is the premier forum for exploring cutting-edge research,
          innovation, and applications in the rapidly evolving domain of smart
          computing, encompassing advancements in sensor-based technologies,
          IoT, cyber-physical systems, edge and cloud computing, big data,
          machine learning, and AI.
        </p>
        <p>
          The workshops at SMARTCOMP 2025 aim to encourage researchers,
          practitioners, and industry experts to exchange ideas, discuss
          emerging trends, and explore novel approaches within the field of
          smart computing.
        </p>
        <h3>Submission Guidelines</h3>
        <p>
          Paper submissions must be no longer than 6 pages (the page count limit
          includes the references list) and formatted according to the
          two-column IEEE proceedings template. All submitted papers that
          conform to these guidelines will be subject to peer reviews by
          Technical Program Committee members and other experts in the field.
          All presented papers will be published in the conference proceedings
          and submitted to the IEEEXplore Digital Library.
        </p>
        <p>
          Since the conference will be an entire in-presence event, no virtual
          or remote presentation will be allowed.
        </p>
        <p>
          Accepted papers must be presented in person by one of the authors, in
          addition to having an associated full registration. Failure to comply
          with this requirement will result in the exclusion of the paper from
          the final proceedings, the conference program and from the IEEE
          Digital Library.
        </p>
        <p>
          We also strongly advise authors of submitted papers to be prepared to
          apply for their Irish visa, if required, as soon as their paper is
          accepted.
        </p>
        <h3>Important Dates</h3>
        <p style={{ marginBottom: 0 }}>
          Paper submission deadline (EXTENDED):{" "}
          <span style={{ fontWeight: "bold", textDecoration: "line-through" }}>
            30th March 2025
          </span>{" "}
          <span style={{ fontWeight: "bold", color: "red" }}>
            21st April 2025
          </span>
        </p>
        <p style={{ marginBottom: 0 }}>
          LIFESEC Paper submission deadline:{" "}
          <span style={{ fontWeight: "bold" }}>14th April 2025 </span>{" "}
        </p>
        <p style={{ marginBottom: 0 }}>
          Paper notification date:{" "}
          <span style={{ fontWeight: "bold" }}>30th April 2025</span>
        </p>
        <p style={{ marginBottom: 0 }}>
          Camera-ready deadline for workshop papers:{" "}
          <span style={{ fontWeight: "bold" }}>10th May 2025</span>
        </p>
        <p style={{ marginBottom: 0 }}>
          Workshop date:{" "}
          <span style={{ fontWeight: "bold" }}>16th June 2025</span>
        </p>
        <p>All deadlines anywhere on earth</p>
        <hr />
        <h3>Publication</h3>
        <p>
          Each accepted paper will require a full SMARTCOMP registration (no
          registration is available for workshops only) and in-person
          presentation. All accepted papers presented in the workshop will be
          published in the proceedings of the conference and published in the
          IEEE Xplore Digital Library and Scopus indexed. Papers that are not
          presented at the workshop will not be published in the proceedings.
        </p>
        <h4>Workshop 1</h4>
        <p>SmartAIDA</p>
        <p>
          1st International Workshop on Smart AI Models and Data Sharing and
          Monetisation
        </p>
        <p>
          General Co-Chairs: Dr Andrea Visentin UCC, Prof. Barry O’Sullivan UCC,
          David Remon Eclipse Foundation.
        </p>
        <p>
          <a href="https://www.cs.ucc.ie/smartaida/">Website</a>
        </p>
        <h4>Workshop 2</h4>
        <p>LIFESEC </p>
        <p>Whole-Lifecycle Security for Smart Systems: Methods and Tools</p>
        <p>
          General Co-Chairs: Robert Seidl Nokia, Antonio Skarmeta University of
          Murcia, and Bernd-Ludwig Wenning MTU.
        </p>
        <p>
          <a href="https://telemetry-project.eu/workshop-on-whole-lifecycle-security-for-smart-systems-methods-and-tools-lifesec/">
            Website
          </a>
        </p>
        <h4>Workshop 3</h4>
        <p>S3PEC</p>
        <p>
          1st International Workshop on Smart Solutions for Security and Privacy
          in the Edge Cloud Continuum
        </p>
        <p>
          General Co-Chairs: Dr. Sourabh Bharti MTU, Dr Alan McGibney MTU, Dr
          Aidan O’Mahony DELL Technologies
        </p>
        <p>
          <a href="https://www.nimbus.cit.ie/s3pec/">Website</a>
        </p>
        <h4>Workshop 4</h4>
        <p>SmartAgr</p>
        <p>
          4th International Workshop on Smart Agriculture for the environmental
          emergency
        </p>
        <p>
          General Co-Chairs: Anna Lina Ruscelli, Scuola Superiore Sant’Anna,
          Gabriele Cecchetti, Scuola Superiore Sant’Anna
        </p>
        <p>
          <a href="https://smartagr.santannapisa.it/">Website</a>
        </p>
        <h4>Workshop 5</h4>
        <p>DM-SmartHealth 2025</p>
        <p>
          2nd International Workshop on Digital and Mobile Smart Health Systems
        </p>
        <p>
          Dr. Mattia Giovanni Campana (National Research Council of Italy,
          Italy), and Prof. Nikil Dutt (University of California, Irvine, USA)
        </p>
        <p>
          <a href="https://dm-smarthealth2025.iit.cnr.it">Website</a>
        </p>
        <h4>Workshop 6</h4>
        <p>SmartSys 2025</p>
        <p>10th IEEE International Workshop on Smart Service Systems</p>
        <p>
          General Co-Chairs: Nirmalya Roy, University of Maryland, Carlo
          Vallati, University of Pisa, Gurdip Singh, George Mason University
        </p>
        <p>
          <a href="http://smartsys2025.dii.unipi.it">Website</a>
        </p>
        <h4>Workshop 7</h4>
        <p>SSC</p>
        <p>11th Workshop on Sensors and Smart Cities </p>
        <p>
          General Co-Chairs: Dario Bruneo, University of Messina, Antonio
          Puliafito, University of Messina
        </p>
        <p>
          <a href="https://portale2.unime.it/ssc2025/">Website</a>
        </p>
      </div>
    </div>
  );
};
